<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.06812 7.81254C9.06812 8.44505 8.5131 8.95779 7.82845 8.95779C7.1438 8.95779 6.58878 8.44505 6.58878 7.81254C6.58878 7.18004 7.1438 6.68507 7.82845 6.68507C8.5131 6.68507 9.06812 7.18004 9.06812 7.81254Z"
      :fill="color"
    />
    <path
      d="M13.407 7.82143C13.407 8.44902 12.8519 8.95779 12.1673 8.95779C11.4826 8.95779 10.9276 8.44902 10.9276 7.82143C10.9276 7.19383 11.4826 6.68507 12.1673 6.68507C12.8519 6.68507 13.407 7.19383 13.407 7.82143Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.88423 1.125C3.94284 1.125 3.17969 1.92449 3.17969 2.91071V18.0893C3.17969 19.0755 3.94284 19.875 4.88423 19.875H15.1115C16.0529 19.875 16.8161 19.0755 16.8161 18.0893V2.91071C16.8161 1.92449 16.0529 1.125 15.1115 1.125H4.88423ZM7.01492 5.58929C5.83817 5.58929 4.88423 6.58865 4.88423 7.82143C4.88423 9.05421 5.83817 10.0536 7.01492 10.0536H12.9808C14.1576 10.0536 15.1115 9.05421 15.1115 7.82143C15.1115 6.58865 14.1576 5.58929 12.9808 5.58929H7.01492Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
const props = defineProps({
  color: {
    type: String,
    required: true,
  },
});
</script>
